import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json'
    },
    ns: [
      'common',
      'ISN',
      'extras',
      'enum',
      'notificaciones',
      'subirArchivos',
      'usuarios',
      'account',
      'roles',
      'telefonos',
      'empresas',
      'direccion',
      'sucursales',
      'ajustesInternos',
      'contactos',
      'cuentasBancarias',
      'datosFiscales',
      'actividadEconomica',
      'empleado',
      'clientes',
      'prestaciones',
      'puestos',
      'puestosSherpa',
      'ajusteLaboral',
      'calculoNomina',
      'umas',
      'factorIntegracion',
      'avisos',
      'patronales',
      'isr',
      'departamentos',
      'faltas',
      'horaExtras',
      'horasOrdinarias',
      'retardos',
      'incapacidades',
      'permisos',
      'diaAjustes',
      'vacaciones',
      'beneficiarios',
      'excepcionMontos',
      'diaHoras',
      'periodo',
      'salarioRetroactivo',
      'prestamos',
      'salarioMinimo',
      'umis',
      'prenomina',
      'clienteAsociados',
      'finiquito',
      'primaAniversario',
      'facturas',
      'dispersiones',
      'plaza',
      'conceptosIva',
      'contrasenas',
      'plantillas',
      'comisionReporte',
      'remision'
    ],
    defaultNS: 'application',
    debug: false,
    react: {
      wait: true
    }
  });

export default i18n;
